 
 const image={
  Assignment_dark:'./img/oleStarted/Assignment_dark.svg',
  Assignment_light:'./img/oleStarted/Assignment_light.svg',
  Attendance_dark:'./img/oleStarted/Attendance_dark.svg',
  Attendance_light:'./img/oleStarted/Attendance_light.svg',
  Cancel:'./img/oleStarted/Cancel.svg',
  Cancel_black:'./img/oleStarted/Cancel_black.png',
  Course_dark:'./img/oleStarted/Course_dark.svg',
  Course_light:'./img/oleStarted/Course_light.svg',
  Dashboard_dark:'./img/oleStarted/Dashboard_dark.svg',
  Dashboard_light:'./img/oleStarted/Dashboard_light.svg',
  Down:'./img/oleStarted/Down.png',
  Home:'./img/oleStarted/Home.png',
  Home_black:'./img/oleStarted/Home_black.png',
  How_dark:'./img/oleStarted/How_dark.svg',
  How_light:'./img/oleStarted/How_light.svg',
  Inner_pages_bg:'./img/oleStarted/Inner_pages_bg.png',
  inner_pages_bg2:'./img/oleStarted/inner_pages_bg2.svg',
  inner_pages_bg1:'./img/oleStarted/inner_pages_bg1.svg',
  Menu:'./img/oleStarted/Menu.png',
  Sub_assignment:'./img/oleStarted/Sub_assignment.svg',
  Sub_attendance:'./img/oleStarted/Sub_attendance.svg',
  Sub_course:'./img/oleStarted/Sub_course.svg',
  Sub_dashboard:'./img/oleStarted/Sub_dashboard.svg',
  Sub_how:'./img/oleStarted/Sub_how.svg',
  Sub_teaching:'./img/oleStarted/Sub_teaching.svg',
  Sub_zoom:'./img/oleStarted/Sub_zoom.svg',
  Teaching_dark:'./img/oleStarted/Teaching_dark.png',
  Teaching_light:'./img/oleStarted/Teaching_light.png',
  Welcome:'./img/oleStarted/Welcome.png',
  Zoom_dark:'./img/oleStarted/Zoom_dark.png',
  Zoom_light:'./img/oleStarted/Zoom_light.png',
  Word:{
    image001:'./img/oleStarted/word/image001.png',
    image002:'./img/oleStarted/word/image002.png',
    image003:'./img/oleStarted/word/image003.png',
    image004:'./img/oleStarted/word/image004.png',
    image005:'./img/oleStarted/word/image005.png',
    image006:'./img/oleStarted/word/image006.png',
    image007:'./img/oleStarted/word/image007.png',
    image008:'./img/oleStarted/word/image008.png',
    image009:'./img/oleStarted/word/image009.png',
    image010:'./img/oleStarted/word/image010.png',
    image011:'./img/oleStarted/word/image011.png',
    image012:'./img/oleStarted/word/image012.png',
    image013:'./img/oleStarted/word/image013.png',
    image014:'./img/oleStarted/word/image014.png',
    image015:'./img/oleStarted/word/image015.png',
    image016:'./img/oleStarted/word/image016.png',
    image017:'./img/oleStarted/word/image017.png',
    image018:'./img/oleStarted/word/image018.png',
    image019:'./img/oleStarted/word/image019.png',
    image020:'./img/oleStarted/word/image020.png',
    image021:'./img/oleStarted/word/image021.png',
    image022:'./img/oleStarted/word/image022.png',
    image023:'./img/oleStarted/word/image023.png',
    image024:'./img/oleStarted/word/image024.png',
    image025:'./img/oleStarted/word/image025.png',
    image026:'./img/oleStarted/word/image026.png',
    image027:'./img/oleStarted/word/image027.png',
    image028:'./img/oleStarted/word/image028.png',
    image029:'./img/oleStarted/word/image029.png',
    image030:'./img/oleStarted/word/image030.png',
    image031:'./img/oleStarted/word/image031.png',
    image032:'./img/oleStarted/word/image032.png',
    image033:'./img/oleStarted/word/image033.png',
    image034:'./img/oleStarted/word/image034.png',
    image035:'./img/oleStarted/word/image035.png',
    image036:'./img/oleStarted/word/image036.png',
    image037:'./img/oleStarted/word/image037.png',
    image038:'./img/oleStarted/word/image038.png',
    image039:'./img/oleStarted/word/image039.png',
    image040:'./img/oleStarted/word/image040.png',
    image041:'./img/oleStarted/word/image041.png',
    image042:'./img/oleStarted/word/image042.png',
    image043:'./img/oleStarted/word/image043.png',
    image044:'./img/oleStarted/word/image044.png',
    image045:'./img/oleStarted/word/image045.png',
    image046:'./img/oleStarted/word/image046.png',
    image047:'./img/oleStarted/word/image047.png',
    image048:'./img/oleStarted/word/image048.png',
    image049:'./img/oleStarted/word/image049.png',
    image050:'./img/oleStarted/word/image050.png',
    image051:'./img/oleStarted/word/image051.png',
    image052:'./img/oleStarted/word/image052.png',
    image053:'./img/oleStarted/word/image053.png',
    image054:'./img/oleStarted/word/image054.png',
    image055:'./img/oleStarted/word/image055.png',
    image056:'./img/oleStarted/word/image056.png',
    image057:'./img/oleStarted/word/image057.png',
    image058:'./img/oleStarted/word/image058.emz',
    image059:'./img/oleStarted/word/image059.png',
    image060:'./img/oleStarted/word/image060.png',
    image061:'./img/oleStarted/word/image061.png',
    image062:'./img/oleStarted/word/image062.jpg',
    image063:'./img/oleStarted/word/image063.png',
    image064:'./img/oleStarted/word/image064.png',
    image065:'./img/oleStarted/word/image065.png',
    image066:'./img/oleStarted/word/image066.png',
    image067:'./img/oleStarted/word/image067.png',
    image068:'./img/oleStarted/word/image068.png',
    image069:'./img/oleStarted/word/image069.png',
    image070:'./img/oleStarted/word/image070.png',
  }
}


exports.Image=image;